import { render } from "./SteamAccountInput.vue?vue&type=template&id=6fa221a0"
import script from "./SteamAccountInput.vue?vue&type=script&lang=js"
export * from "./SteamAccountInput.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Documents\\src\\steam-what-to-play-together\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__